module.exports = __webpack_public_path__ + "static/media/442.9fce63e9.webp";